import {
  EuiFieldSearch,
  EuiHeaderSection,
  EuiHeaderSectionItem,
  EuiHeaderSectionItemButton,
  EuiIcon,
  EuiImage,
  EuiSelectableMessage,
  EuiSelectableTemplateSitewide,
  EuiSpacer,
} from "@elastic/eui";
import {
  Anchor,
  AppShell,
  Burger,
  Button,
  Divider,
  Flex,
  Group,
  ScrollArea,
  Switch,
  Text,
  Tooltip,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { nprogress } from "@mantine/nprogress";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useNavigation,
} from "react-router-dom";
import { _sideNavData } from "../../../_setup/navdata/_sideNavData";
import { getMenuByEmp } from "../../../api/ApiAdmin";
import { UserMenu } from "../../../components/UserMenu/UserMenu";
import { useAuth } from "../../../contexts/AuthContext";
import classes from "../../_style/NavbarSegmented.module.css";
import { isNullOrEmpty } from "../../extension/StringExtension";
import { searchSideNavData } from "../../helper/FunctionHelper";
import { AuthProvider } from "../../helper/IAuthProvider";
import { LinksGroupProps } from "../../model/_base/LinksGroupProps";
import { SkeletonBase } from "./_skeleton";
import { LinksGroup } from "./NavbarLinksGroup";

//context

export const Layout = () => {
  // #region state
  const [environment, setEnvironment] = useState<string | undefined>("");
  const location = useLocation();
  const [progress, setProgress] = useState(true);
  const navigation = useNavigation();
  const navigate = useNavigate();
  const [loadingSkeleton, setLoadingSkeleton] = useState(true);
  useEffect(() => {
    const env = window.location.hostname.includes("web-manager.hacom.vn")
      ? "production"
      : "development";
    setEnvironment(env);
  }, []);
  useEffect(() => {
    if (!localStorage.getItem("checkedPinSearch")) {
      localStorage.setItem("checkedPinSearch", "true");
      setChecked(true);
    }
  }, []);
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const [sideNavs, setSideNavs] = useState<LinksGroupProps[]>([]);
  const [checkMenu, setCheckMenu] = useState<string[]>([]);
  const [checkMenuDetail, setCheckMenuDetail] = useState<string[]>([]);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [checked, setChecked] = useState(
    localStorage.getItem("checkedPinSearch") == "true"
  );

  //#endregion

  //#region  auth
  const listRouterIgnore = [""];
  const isAuthenticated = AuthProvider.isAuthenticated();

  //#endregion
  useEffect(() => {
    setLoadingSkeleton(false);
    //   nprogress.start()
    window.scrollTo(0, 0);
    // if (
    //   !listRouterIgnore.includes(location.pathname) &&
    //   isAuthenticated === false
    // ) {
    //   navigate("/auth/login?callback=" + location.pathname);
    // } else console.log(" check auth " + location.pathname);
    setSideNavs(_sideNavData);

    // Thêm event listener để kiểm tra cuộn
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      nprogress.start();
      setLoadingSkeleton(true);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  // Hàm để cuộn lên đầu trang
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // matine
  const [opened, { toggle }] = useDisclosure();
  const search = (
    <EuiSelectableTemplateSitewide
      options={[]}
      searchProps={{
        compressed: true,
      }}
      popoverButton={
        <EuiHeaderSectionItemButton flush="left" aria-label="Sitewide search">
          <EuiIcon type="search" size="m" />
        </EuiHeaderSectionItemButton>
      }
      emptyMessage={
        <EuiSelectableMessage style={{ minHeight: 300 }}>
          Danh sách kết quả tìm kiếm...
          <Link to="/">Trang chủ</Link>
        </EuiSelectableMessage>
      }
    />
  );
  const renderLogo = () => (
    <EuiImage
      margin="s"
      size="s"
      alt="" // Because this image is sufficiently described by its caption, there is no need to repeat it via alt text
      src="https://hanoicomputercdn.com/media/lib/09-08-2023/logo-hacom-since-2001.png"
    />
  );
  // search menu
  function searchDataSide(q: string) {
    if (isNullOrEmpty(q)) return setSideNavs(_sideNavData);
    return setSideNavs(searchSideNavData(sideNavs, q));
  }
  const searchModel = (
    <EuiFieldSearch
      placeholder="Tìm kiếm"
      // value={value}
      onChange={(e: any) => searchDataSide(e.target.value)}
      // isClearable={isClearable}
    />
  );
  const searchMenu = <EuiHeaderSectionItem>{searchModel}</EuiHeaderSectionItem>;

  const getStaticPath = (pathname: string) => {
    const arr = pathname.split("/");
    // Nếu path có đúng 4 phần (ví dụ: /combo/combo-set-edit/711)
    if (arr.length === 4) {
      // Lấy 3 phần đầu: ["", "combo", "combo-set-edit"] => "/combo/combo-set-edit"
      return arr.slice(0, 3).join("/");
    }
    // Nếu dài hơn thì lấy 4 phần đầu (phòng trường hợp có thêm segment động)
    if (arr.length > 4) {
      return arr.slice(0, 4).join("/");
    }
    return pathname;
  };
  const handleCheckMenu = async () => {
    if (
      JSON.parse(localStorage.getItem("userData") ?? "")?.userName !==
      "quan-1509"
    ) {
      const res = await getMenuByEmp();

      if (res && res?.success) {
        const result = res.data.map((item: any) => {
          const parts = item.keyApi.split("/");
          return `/${parts[1]}`;
        });
        const listMenu = res.data.map((item: any) =>
          String(item.keyApi).replace("/:id", "")
        );
        setCheckMenu(result);
        setCheckMenuDetail(listMenu);

        // if (!listMenu.includes(location.pathname)) {
        //   navigate("/");
        // }
        const staticPath = getStaticPath(location.pathname);
        console.log("Static Path:", staticPath);
        if (!listMenu.includes(staticPath)) {
          navigate("/");
        }
      } else {
        navigate("/");
      }
    } else {
      return;
    }
  };
  useEffect(() => {
    if (localStorage.getItem("userData") && localStorage.getItem("authToken")) {
      handleCheckMenu();
    }
  }, [location.pathname, localStorage.getItem("authToken")]);

  const links =
    JSON.parse(localStorage.getItem("userData") ?? "")?.userName !== "quan-1509"
      ? sideNavs
          .filter(
            (item) =>
              item.link !== undefined &&
              checkMenu.includes(item.link.toString())
          )
          .map((item) => (
            <LinksGroup
              {...item}
              key={item.label}
              checkMenu={checkMenuDetail}
            />
          ))
      : sideNavs
          .filter((item) => item.link !== undefined)
          .map((item) => <LinksGroup {...item} key={item.label} />);

  const { user } = useAuth();

  return (
    <>
      <AppShell
        header={{ height: environment === "production" ? 60 : 90 }}
        navbar={{
          width: 300,
          breakpoint: "md",
          collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
        }}
        padding="xs"
      >
        <AppShell.Header>
          {environment === "development" && (
            <Flex direction="column">
              {/* Hàng thông báo phiên bản thử nghiệm */}
              <Flex justify="center" align="center" bg="#FFD700">
                <Text size="md" fw="bold" color="red">
                  Đây là phiên bản thử nghiệm. Vui lòng truy cập{" "}
                  <Anchor
                    href="https://web-manager.hacom.vn"
                    target="_blank"
                    color="blue"
                  >
                    link này
                  </Anchor>{" "}
                  để vào bản chính thức.
                </Text>
              </Flex>
            </Flex>
          )}
          <Group px="md" justify="space-between" align="center" wrap="wrap">
            <EuiHeaderSection>
              <Group h="100%" px="md">
                {/* <Burger
                  opened={mobileOpened}
                  onClick={toggleMobile}
                  hiddenFrom="md"
                  size="sm"
                /> */}
                <Burger
                  opened={desktopOpened}
                  onClick={toggleDesktop}
                  visibleFrom="md"
                  size="sm"
                />
              </Group>
            </EuiHeaderSection>
            <EuiHeaderSection>
              <EuiHeaderSectionItem>{renderLogo()}</EuiHeaderSectionItem>
            </EuiHeaderSection>
            <EuiHeaderSection>
              <EuiHeaderSectionItem></EuiHeaderSectionItem>
            </EuiHeaderSection>
            <EuiSpacer size="l" />
            <EuiHeaderSection side="right">
              <EuiHeaderSectionItem>
                <Tooltip
                  transitionProps={{ transition: "pop", duration: 300 }}
                  refProp="rootRef"
                  label={checked ? "Bỏ lưu tìm kiếm" : "Lưu tìm kiếm"}
                >
                  <Switch
                    size="lg"
                    mt={5}
                    checked={checked}
                    onChange={(event) => {
                      const checked = event.currentTarget.checked;
                      if (checked) {
                        localStorage.setItem("checkedPinSearch", "true");
                        setChecked(true);
                      } else {
                        localStorage.setItem("checkedPinSearch", "false");
                        setChecked(false);
                      }
                    }}
                    color="blue"
                    thumbIcon={
                      checked ? (
                        <IconCheck
                          size={12}
                          color="var(--mantine-color-teal-6)"
                          stroke={3}
                        />
                      ) : (
                        <IconX
                          size={12}
                          color="var(--mantine-color-red-6)"
                          stroke={3}
                        />
                      )
                    }
                  />
                </Tooltip>
              </EuiHeaderSectionItem>
              <EuiHeaderSectionItem>
                <Flex align={"center"}>
                  <Divider size="sm" orientation="vertical" ml={20} h={40} />
                </Flex>
              </EuiHeaderSectionItem>
              <EuiHeaderSectionItem>
                <UserMenu />
              </EuiHeaderSectionItem>
            </EuiHeaderSection>
            <EuiHeaderSection>
              <EuiHeaderSectionItem>{search}</EuiHeaderSectionItem>
            </EuiHeaderSection>
          </Group>
        </AppShell.Header>
        <AppShell.Navbar p="md">
          <AppShell.Section>{searchMenu}</AppShell.Section>
          <AppShell.Section grow component={ScrollArea}>
            <ScrollArea className={classes.links}>
              <div className={classes.linksInner}>{links}</div>
            </ScrollArea>
          </AppShell.Section>
          <AppShell.Section>{/* Đã xóa UserMenu ở đây */}</AppShell.Section>
        </AppShell.Navbar>
        <AppShell.Main>
          {loadingSkeleton ? (
            <SkeletonBase visible={loadingSkeleton}></SkeletonBase>
          ) : (
            <>
              {/* <_breadcrumb></_breadcrumb> */}
              <Outlet />
              {showScrollTop && (
                <Button
                  onClick={scrollToTop}
                  style={{
                    position: "fixed",
                    bottom: "30px",
                    right: "30px",
                    zIndex: 1000,
                    borderRadius: "50%",
                    width: "50px",
                    height: "50px",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(135deg, #228be6, #4dabf7)",
                    boxShadow:
                      "0 10px 25px rgba(0, 0, 0, 0.25), 0 0 15px rgba(74, 144, 226, 0.6)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",
                    border: "none",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.15)";
                    e.currentTarget.style.boxShadow =
                      "0 12px 30px rgba(0, 0, 0, 0.35), 0 0 25px rgba(74, 144, 226, 0.8)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 25px rgba(0, 0, 0, 0.25), 0 0 15px rgba(74, 144, 226, 0.6)";
                  }}
                >
                  <EuiIcon type="arrowUp" size="m" color="white" />
                </Button>
              )}
            </>
          )}
        </AppShell.Main>
      </AppShell>
    </>
  );
};
